import React, { useState } from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnWhite, HeroBg, HeroBgAr, HeroImg, HeroImg2, Whatsapp, WhatsAppCtnt, WhatsIcon, WhatsIconBtn } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, ButtonWithIcon2, ContactButton, ContactButtonHref, ContactButtonLink } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import PricingModal from '../../pricingmodal/PricingModal'
const Banner = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966567974344';
        const message = 'Hello, this is Soola';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid'  id='home'>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} className="bannerColMain">
                            <Box className='bannerContent'>
                                
                                <MainHeading className='main-heading main-heading-banner-sub' size="32px" color="var(--white)">
                                    {t('SmartQuotingTitle')}
                                </MainHeading>
                                <MainHeading className='main-heading mb-3 main-heading-banner' size="70px" color="var(--white)">
                                    {t('SmartQuotingSubtitle')}
                                </MainHeading>

                                <SpanStyled className='mb-4 bannerTxt' size="24px" color="var(--white)">
                                    {t('SmartQuotingDesc')}
                                </SpanStyled>
                                <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap banBtnWrap'>
                                    <ContactButtonLink href='#!' icon={ArrowBtnWhite} label={t('GetStartedFree')} onClick={() => setShowModal(true)} />
                                    {/* <WhatsAppCtnt className='drWhatsBtn cursor-pointeer' onClick={WhatsApp} /> */}
                                    {/* <ButtonWithIcon2 className='drWhatsBtn cursor-pointeer' bg="#25D366" icon={WhatsIconBtn} label={t('whatsapp')} onClick={WhatsApp} /> */}
                                    
                                </SpanStyled>
                                
                            </Box>
                            <Box className="heroImgContainer">
                                {i18n.language === "en" ? 
                                    <img src={HeroImg} alt="HeroImage" className="heroImg" />
                                    : 
                                    <img src={HeroImg2} alt="HeroImage" className="heroImg" />
                                    }
                                
                                
                            </Box>
                        </Col>
                        
                    </Box>
                </Container>
            </BannerWapper>

            <PricingModal
                show={showModal}
                handleClose={() => setShowModal(false)}
            />
        </>
    )
}
const BannerWapper = styled.section`
    padding-bottom: 2px;
    
    /* height: 745px; */
    padding-top: 104px;
    & > .container{
        .bannerColMain{
            height: 614px;
            background-image: url(${HeroBg});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: left center;
            border-radius: 16px;
            overflow: hidden;
            display: flex;
            align-items: center;
            padding-left: 80px;
            padding-right: 80px;
            position: relative;
            .bannerContent{
                display: flex;
                width: 560px;
                flex-wrap: wrap;
                flex-direction: column;
                /* padding-top: 107px; */
                /* padding-left: 168px; */
                
            }
        }
        
    }
    .bannerRow{
        padding: 0px 0px 0 0px;
        align-items: center;
        margin-left: 0;
        margin-right: 0;
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    .heroImgContainer{
        position: absolute;
        right: 40px; 
        bottom: 0;
    }
    body.rtl &{
        & > .container{
            .bannerColMain{
                background-image: url(${HeroBgAr});
                background-position: right center;
                .bannerContent{
                    /* padding-top: 150px;
                    padding-left: 0;
                    padding-right: 168px; */
                    
                }
            }
        }
        .main-heading-banner-sub{
            font-size: 28px;
            margin-bottom: 5px;
        }
        .heroImgContainer{
            right: auto; 
            left: 40px; 
        }
        
        .bannerRow{
            padding: 0px 0px 0 0px;
            align-items: center;
            
        }
        
        /* .bannerCol1{
            padding-bottom: 60px !important;
        } */
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
                
            }
        }
    }
    @media (max-width: 1299px) {
        .heroImgContainer {
            right: -20px;
        }
        &.bannerFluid .bannerColMain{
            padding-left: 20px;
            padding-right: 20px;
        }
        body.rtl &{
            .heroImgContainer {
                right: auto;
                left: -20px;
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        /* .main-heading{
            font-size: 55px;
        } */
        .bannerColMain .bannerContent {
            width: 430px !important; 
        }
        /* .heroImgContainer{
            max-width: 500px;
            bottom: 110px;
        } */

    }
     @media (max-width: 1099px) {
        padding-top: 84px;
        .bannerColMain .bannerContent {
            width: 350px !important;
        }
     }
    @media (max-width: 991px) {
        padding-top: 84px;
        height: auto;
        /* .main-heading{
            font-size: 45px;
            text-align: center;
        } */
        .bannerSubTxt{
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .bannerSubDetailTxt{
            text-align: center;
            display: inline-block;
        }
        .bannerImgContainer{
            justify-content: center !important;
            padding-top: 0px;
        }
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        .bannerColMain {
            height: auto !important;
            padding-top: 60px;
            padding-bottom: 70px;
            .bannerContent {
             width: 100% !important;
             justify-content : center;
             & > *{
                text-align: center;
             }
            }
        }
        .heroImgContainer{
            display: none;
        }
        .banBtnWrap{
            justify-content: center;
        }
        .main-heading-banner{
            font-size: 40px;
        }
        .main-heading-banner-sub{
            font-size: 25px;
        }
        .bannerTxt{
            font-size: 18px;
        }
        body.rtl &{
            
            .bannerSubTxt{
                font-size: 26px;
            }
        }
    }
    @media (max-width: 767px) {
        
        body.rtl &{
            
             
        }
    }
    @media (max-width: 640px) {
        /* padding-top: 80px; */
        body.rtl &{
            .main-heading{
                font-size: 35px;
            }
            .bannerSubTxt{
                font-size: 24px;
            }
            .main-heading-banner-sub{
                font-size: 25px;
            }
        }
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 350px) {
        & > .container{
            .bannerColMain{
                .bannerContent{
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
`
export default Banner
